import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class GuestValidateMPINUseCase extends BaseUseCase {
    constructor(loginFLowRepo) {
        super();
        this.loginFLowRepo = loginFLowRepo;
    }
    fetchResult(req) {
        return this.loginFLowRepo.guestLoginValidateMPIN(req);
    }
}
export default GuestValidateMPINUseCase;
